import React from "react"
import { connect } from "react-redux"
import { Route, Redirect } from "react-router-dom"
import propTypes from "prop-types"

const PrivateRoute = ({ component: Component, store, roles, ...rest }) => {
  const role = store.user.list_role

  return (
    <Route
      render={props => {
        if (store.isLogged) {
          if (roles) {
            const hasAccess = roles.some(r => role.includes(r))

            if (hasAccess) {
              return <Component {...props} {...rest} />
            }
            return (
              <Redirect
                to={{
                  pathname: "/",
                  state: { from: props.location }
                }}
              />
            )
          }
          return <Component {...props} {...rest} />
        }
        return (
          <Redirect
            to={{
              pathname: "/sign-up",
              state: { from: props.location }
            }}
          />
        )
      }}
    />
  )
}

PrivateRoute.defaultProps = {
  roles: []
}

PrivateRoute.propTypes = {
  component: propTypes.oneOfType([
    propTypes.node,
    propTypes.element,
    propTypes.func,
    propTypes.elementType
  ]).isRequired,
  location: propTypes.shape({
    state: propTypes.shape({
      from: propTypes.object
    })
  }).isRequired,
  roles: propTypes.arrayOf(
    propTypes.oneOfType([propTypes.string, propTypes.number])
  ),
  store: propTypes.shape({
    isLogged: propTypes.bool.isRequired,
    user: propTypes.shape({
      list_role: propTypes.arrayOf(propTypes.number)
    }).isRequired
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  store: {
    isLogged: AuthenticationReducer.isLogged,
    user: AuthenticationReducer.user
  }
})

export default connect(mapStateToProps)(PrivateRoute)
